var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._b({staticClass:"TRC-AppButton",class:_vm.buttonClasses,attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},'button',_vm.$attrs,false),[(_vm.isProcessing)?[_c('app-spinner',{attrs:{"size":"small"}})]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }